import { ResourceSearchConfig } from '@/components/resource-search/ResourceSearchForm.types';
import {
  BaseSearchParams,
  useResourceSearch,
} from '@/pages/ainigma/lims/hooks/useResourceSearch';
import { MedplumClient } from '@medplum/core';
import { Resource } from '@medplum/fhirtypes';

export function useGenericResourceSearch<
  TParams extends BaseSearchParams,
  TResource extends Resource,
>(
  medplum: MedplumClient,
  config: ResourceSearchConfig<TParams, TResource>,
  patientId?: string
) {
  const suggestionFetcher =
    config.getResourceIdSuggestions ?? (async () => [] as string[]);

  const needsFilterFn = config.needsClientSideFiltering;
  const needsClientFilter = needsFilterFn
    ? (params: BaseSearchParams) => needsFilterFn(params as TParams)
    : undefined;

  const clientFilterFn = config.clientSideFilter;
  const clientFilter = clientFilterFn
    ? (resources: TResource[], params: BaseSearchParams, bundle: any) =>
        clientFilterFn(resources, params as TParams, medplum, bundle)
    : undefined;

  return useResourceSearch<TResource>({
    medplum,
    resourceType: config.resourceType as TResource['resourceType'],
    patientId,
    itemsPerPage: config.itemsPerPage,
    buildSearchQuery: (params, page, itemsPerPage) =>
      config.buildSearchQuery(params as TParams, page, itemsPerPage),
    getResourceIdSuggestions: suggestionFetcher,
    needsClientSideFiltering: needsClientFilter,
    clientSideFilter: clientFilter,
    processBundleData: config.processBundleData,
  });
}
